module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_162816-removebg-preview-a42f82280451878bcd2ac5da04590653.png";